const submit = function (_event) {
  var form = $(this).parents("form").get(0);
  window.Rails.fire(form, "submit");
};

$(document).on("change", "form[data-auto-submit] :input", submit);
$(document).on("keyup", "form[data-auto-submit] textarea", submit);
